import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './lib/auth';
import App from './App';
import './styles/tokens.css';

// Mobile/tablet (<900px) → redirect alla SPA mobile-first esistente.
// Pro web è desktop-only by design; mobile pro usa il flow stencil su dietamenu.schedy.app.
//
// Escape hatch ?force_desktop=1 bypassa il redirect (utile da debug / browser con devtools).
const MOBILE_BREAKPOINT = 900;

if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const forceDesktop = params.get('force_desktop') === '1';
  const width = window.innerWidth;

  // eslint-disable-next-line no-console
  console.log('[pro-web] viewport width:', width, '· force_desktop:', forceDesktop, '· path:', window.location.pathname);

  if (!forceDesktop && width < MOBILE_BREAKPOINT) {
    const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) || 'https://dietamenu.schedy.app';
    // eslint-disable-next-line no-console
    console.log('[pro-web] viewport <900px → redirect mobile a', apiBase);
    window.location.replace(`${apiBase}/?portal=pro`);
    // Stop bootstrap: la replace navigate via in pochi ms, non renderizziamo nulla nel frattempo.
    throw new Error('redirect-mobile');
  }
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
